import Vue from 'vue';
import Vuex from 'vuex';
import BackendService from '../services/BackendService.js';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        snackbars: [],
        quickscan: {
            loggedIn: false,
            step1: {
                complete: false,
                applicant: {
                    initials: null,
                    lastname: null,
                    tussenvoegsel: null,
                    phone: null,
                    gender: null,
                    email: null,
                    birthdate: null,
                    address: null,
                    zipcode: null,
                    city: null,
                    hasOtherContact: null,
                },
                application: {
                    shortDescription: null,
                },
            },
            step2: {
                complete: false,
                applicant: {
                    hasOtherContact: null,
                    gender: null,
                },
                contact: {
                    name: null,
                    gender: null,
                    phone: null,
                    email: null,
                },

                application: {
                    shortDescription: null,
                    enteredTruthfully: null,
                },
            },
            step3: {
                complete: false,

                applicant: {
                    name: null,
                    address: null,
                    zipcode: null,
                    gender: null,
                    city: null,
                    email: null,
                    phone: null,
                },
                contact: {
                    name: null,
                    gender: null,
                    phone: null,
                    email: null,
                },
                application: {
                    shortDescription: null,
                    enteredTruthfully: null,
                    preferedVersion: null,
                },
            },
            finish: {
                complete: false,
                preferedVersion: 'digitaal',
                valid: null,
                submitted: null,
                error: null,
            },
        },
    },
    mutations: {
        SNACKBAR_ADDED(state, payload) {
            state.snackbars.push(payload);
        },
        SNACKBAR_REMOVE_TOP(state) {
            state.snackbars.shift();
        },
        QUICKSCAN_LOGGED_IN(state, payload) {
            state.quickscan.loggedIn = true;
            BackendService.setToken(payload.data.token);
        },
        QUICKSCAN_LOGGED_OUT(state) {
            state.quickscan.loggedIn = false;
            // removes all state from session
            location.assign('/quickscan');
        },
        QUICKSCAN_STEP1_UPDATE(state, payload) {
            state.quickscan.step1.applicant.initials = payload.data.applicant.initials;
            state.quickscan.step1.applicant.lastname = payload.data.applicant.lastname;
            state.quickscan.step1.applicant.tussenvoegsel = payload.data.applicant.tussenvoegsel;
            state.quickscan.step1.applicant.phone = payload.data.applicant.phone;
            state.quickscan.step1.applicant.email = payload.data.applicant.email;
            state.quickscan.step1.applicant.gender = payload.data.applicant.gender;
            state.quickscan.step1.applicant.birthdate = payload.data.applicant.birthdate;
            state.quickscan.step1.applicant.address = payload.data.applicant.address;
            state.quickscan.step1.applicant.zipcode = payload.data.applicant.zipcode;
            state.quickscan.step1.applicant.city = payload.data.applicant.city;
            state.quickscan.step1.applicant.hasOtherContact = payload.data.applicant.hasOtherContact;
            state.quickscan.step1.application.shortDescription = payload.data.application.shortDescription;
            state.quickscan.step1.complete = payload.data.complete;
        },
        QUICKSCAN_STEP2_UPDATE(state, payload) {
            state.quickscan.step2.application.shortDescription = payload.data.application.shortDescription;
            state.quickscan.step2.application.enteredTruthfully = payload.data.application.enteredTruthfully;
            state.quickscan.step2.applicant.hasOtherContact = payload.data.applicant.hasOtherContact;
            state.quickscan.step2.applicant.gender = payload.data.applicant.gender;
            state.quickscan.step2.complete = payload.data.complete;
            state.quickscan.step2.contact.name = payload.data.contact.name;
            state.quickscan.step2.contact.gender = payload.data.contact.gender;
            state.quickscan.step2.contact.phone = payload.data.contact.phone;
            state.quickscan.step2.contact.email = payload.data.contact.email;
        },
        QUICKSCAN_STEP3_UPDATE(state, payload) {
            state.quickscan.step3.applicant.name = payload.data.applicant.name;
            state.quickscan.step3.applicant.gender = payload.data.applicant.gender;
            state.quickscan.step3.applicant.address = payload.data.applicant.address;
            state.quickscan.step3.applicant.zipcode = payload.data.applicant.zipcode;
            state.quickscan.step3.applicant.city = payload.data.applicant.city;
            state.quickscan.step3.applicant.email = payload.data.applicant.email;
            state.quickscan.step3.applicant.phone = payload.data.applicant.phone;
            state.quickscan.step3.application.shortDescription = payload.data.application.shortDescription;
            state.quickscan.step3.application.preferedVersion = payload.data.application.preferedVersion;
            state.quickscan.step3.application.enteredTruthfully = payload.data.application.enteredTruthfully;
            state.quickscan.step3.complete = payload.data.complete;
        },
        QUICKSCAN_FINISH_UPDATE(state, payload) {
            state.quickscan.finish.complete = payload.data.complete;
            state.quickscan.finish.valid = payload.data.valid;
            state.quickscan.finish.preferedVersion = payload.data.preferedVersion;
            state.quickscan.finish.submitted = payload.data.submitted;
            state.quickscan.finish.error = !payload.data.valid;
        },
        QUICKSCAN_FINISH_RESET(state) {
            state.quickscan.finish.complete = false;
            state.quickscan.finish.valid = false;
            state.quickscan.finish.submitted = false;
            state.quickscan.finish.error = false;
        },
    },
    actions: {
        addSnackbar({ commit }, payload) {
            const snackbar = {
                message: payload,
            };
            commit('SNACKBAR_ADDED', snackbar);
        },
        removeTopSnackbar({ commit }) {
            commit('SNACKBAR_REMOVE_TOP');
        },
        async quickscanLogin({ state, commit }) {
            const response = await BackendService.quickscanLogin();
            commit('QUICKSCAN_LOGGED_IN', response.data);
            return state.quickscan.loggedIn;
        },
        async quickscanLogout({ commit }) {
            commit('QUICKSCAN_LOGGED_OUT');
        },
        async quickscanStep1Load({ commit }) {
            const response = await BackendService.quickscanStep1Load();
            commit('QUICKSCAN_STEP1_UPDATE', response.data);
        },
        async quickscanStep1Submit({ commit }, payload) {
            const response = await BackendService.quickscanStep1Submit(payload);
            commit('QUICKSCAN_STEP1_UPDATE', response.data);
        },
        async quickscanStep2Load({ commit }) {
            const response = await BackendService.quickscanStep2Load();
            commit('QUICKSCAN_STEP2_UPDATE', response.data);
        },
        async quickscanStep2Submit({ commit }, payload) {
            const response = await BackendService.quickscanStep2Submit(payload);
            commit('QUICKSCAN_STEP2_UPDATE', response.data);
        },
        async quickscanStep3Load({ commit }) {
            const response = await BackendService.quickscanStep3Load();
            commit('QUICKSCAN_STEP3_UPDATE', response.data);
        },
        async quickscanStep3Submit({ commit }, payload) {
            const response = await BackendService.quickscanStep3Submit(payload);
            commit('QUICKSCAN_STEP3_UPDATE', response.data);
        },
        async quickscanFinishLoad({ commit }) {
            const response = await BackendService.quickscanFinishLoad();
            commit('QUICKSCAN_FINISH_UPDATE', response.data);
        },
        async quickscanFinishSubmit({ commit }, payload) {
            const response = await BackendService.quickscanFinishSubmit(payload);
            commit('QUICKSCAN_FINISH_UPDATE', response.data);
        },
        async quickscanFinishReset({ commit }) {
            commit('QUICKSCAN_FINISH_RESET');
        },
    },
    getters: {
        snackbars(state) {
            return state.snackbars;
        },
        quickscanLoggedIn(state) {
            return state.quickscan.loggedIn;
        },
        stepsComplete(state) {
            return {
                step1: state.quickscan.step1.complete,
                step2: state.quickscan.step2.complete,
                step3: state.quickscan.step3.complete,
                finish: {
                    complete: state.quickscan.finish.complete,
                    error: state.quickscan.finish.error,
                },
            };
        },
        step1(state) {
            return state.quickscan.step1;
        },
        step2(state) {
            return state.quickscan.step2;
        },
        step3(state) {
            return state.quickscan.step3;
        },
        finish(state) {
            return state.quickscan.finish;
        },
    },
    modules: {},
});
